

























import { useUiState } from '~/composables';
import { defineComponent } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  components: {
    SvgImage,
  },
  setup() {
    const { changeToCategoryListView, changeToCategoryGridView, isCategoryGridView } = useUiState();

    return {
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
    };
  },
});
